import { trainingLog } from 'common/models'
import { keyBy } from 'lodash'
import { ActionType, getType } from 'typesafe-actions'

import * as logsActions from './actionCreators'

export type LogActionType = ActionType<typeof logsActions>

interface LogsState {
  trainingLogs: Dict<any>
}

const initialState: Readonly<LogsState> = {
  trainingLogs: {},
}

export default (state = initialState, action: LogActionType) => {
  switch (action.type) {
    case getType(logsActions.getTrainingLogs.success): {
      const trainingLogs: Dict<trainingLog> = keyBy(action.payload, '_id')
      return {
        ...state,
        trainingLogs,
      }
    }
    default:
      return state
  }
}
